import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ToastService } from '@ceslicensing/toast-notification';
import { Observable } from 'rxjs';
import { AuthService as Auth0Service } from '@auth0/auth0-angular';
import { environment } from '@env/environment';
import { TokenService } from '@app/shared/services/token.service';
@Injectable({
  providedIn: 'root',
})
export class AppAccesshGuardService implements CanActivate {
  constructor(
    private toast: ToastService,
    private router: Router,
    private auth0Service: Auth0Service,
    private tokenService: TokenService
  ) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    this.auth0Service.user$.subscribe((response: any) => {
      if (
        response?.app_metadata?.apps.some(
          (item) => item.authAppClientId == environment.auth.client_id
        ) &&
        this.tokenService.checkSuperAdmin()
      ) {
        return true;
      } else {
        this.toast.error("You don't have access to SSO admin app, please contact admin");
        this.router.navigate(['/account/apps']);
        return false;
      }
    });
    return true;
  }
}
